import React, { useContext } from "react";
import { IoIosGlobe } from "react-icons/io";
import { MdOutlineEdit, MdOutlinePerson } from "react-icons/md";
import { RiLockPasswordLine, RiTicketLine } from "react-icons/ri";
import { AuthContext } from "../../../Context/AuthContextProvider";
import "./dummy.css";

function CheckUserPassword() {
  const { loginUser } = useContext(AuthContext);
  const isPasswordSet = loginUser.password;

  return (
    <span className="ripple-container">
      {isPasswordSet ? "Change Password" : "Add Password"}
      {!isPasswordSet && <span className="ripple-dot"></span>}{" "}
      {/* Ripple effect dot */}
    </span>
  );
}
export const links = [
  {
    title: "Profile",
    links: [
      {
        id: 1,
        name: "Personal Info",
        link: "Dashboard/Profile",
        icon: <MdOutlinePerson className="text-[20px]" />,
      },
      {
        id: 2,
        name: "Edit Profile",
        link: "Dashboard/EditAccountDetails",
        icon: <MdOutlineEdit className="text-[20px]" />,
      },
      {
        id: 3,
        name: <CheckUserPassword />,
        link: "Dashboard/Changepassword",
        icon: <RiLockPasswordLine className="text-[20px]" />,
      },
    ],
  },

  {
    title: "Activity",
    links: [
      {
        id: 4,
        name: "Domains",
        link: "Dashboard/Domains",
        icon: <IoIosGlobe className="text-[20px]" />,
      },
      {
        id: 5,
        name: "My Submissions",
        link: "Dashboard/Mysubmissions",
        icon: <IoIosGlobe className="text-[20px]" />,
      },
    ],
  },
  {
    title: "Support",
    links: [
      {
        id: 7,
        name: "Tickets",
        link: "Dashboard/AllTickets",
        icon: <RiTicketLine className="text-[20px]" />,
      },
    ],
  },
];
